export default __webpack_public_path__ + "static/media/across.753364ba.svg";